import React from 'react';

export default function SVGPhoneVariant({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${className ? className : 'text-iconStrong fill-current'} `}
      width="18"
      height="30"
      viewBox="0 0 18 30"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.946289 3.45159C0.946289 1.80718 2.27935 0.474121 3.92376 0.474121H14.9906C16.635 0.474121 17.968 1.80718 17.968 3.4516V26.4966C17.968 28.1411 16.635 29.4741 14.9906 29.4741H3.92377C2.27935 29.4741 0.946289 28.1411 0.946289 26.4966V3.45159ZM2.75879 4.09912H16.3525V25.8491H2.75879V4.09912ZM9.50645 3.0798C9.91756 3.0798 10.2508 2.74654 10.2508 2.33543C10.2508 1.92433 9.91756 1.59106 9.50645 1.59106C9.09535 1.59106 8.76208 1.92433 8.76208 2.33543C8.76208 2.74654 9.09535 3.0798 9.50645 3.0798Z"
      />
    </svg>
  );
}
